const env: any = process.env.REACT_APP_STAGE;

export const STAGES = {
  LOCAL: 'LOCAL',
  DEV: 'dev',
  BETA: 'beta',
  PROD: 'prod'
};

let _API_ = {
  CORE: 'http://localhost:8080/'
};

let _ENV_NAME_ = STAGES.LOCAL;

switch (env) {
  case 'develop':
    _API_ = {
      CORE: 'https://dev-api.chatbridge.mx/'
    };
    _ENV_NAME_ = STAGES.DEV;

    break;
  case 'beta':
    _API_ = {
      CORE: 'https://beta-api.chatbridge.mx/'
    };
    _ENV_NAME_ = STAGES.BETA;

    break;
  case 'prod':
    _API_ = {
      CORE: 'https://api.chatbridge.mx/'
    };
    _ENV_NAME_ = STAGES.PROD;
    break;

  default:
    break;
}

export const API_ENDPOINT = _API_;
export const ENV_NAME = _ENV_NAME_;

export const STORAGE_PREFIX = 'chatbridge-';

export const STORAGE = {
  TOKEN: STORAGE_PREFIX + 'token',
  SESSION: STORAGE_PREFIX + 'session',
  SELECTED_ACCOUNT: STORAGE_PREFIX + 'selected_account',
  ACCOUNTS: STORAGE_PREFIX + 'accounts'
};

export const PROFILES = {
  ROOT: 'ROOT',
  ADMIN: 'ADMIN',
  STANDARD_USER: 'STANDARD_USER',
  AGENTE: 'AGENT'
};
